import { render, staticRenderFns } from "./bank-account.vue?vue&type=template&id=188e2984"
import script from "./bank-account.vue?vue&type=script&lang=js"
export * from "./bank-account.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports